/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
import { h } from "@stencil/core";
export const CSS = {
    validationContainer: "validation-container",
};
export const Validation = ({ scale, status, id, icon, message, }) => (h("div", { class: CSS.validationContainer }, h("calcite-input-message", { "aria-live": "polite", icon: icon, id: id, scale: scale, status: status }, message)));
//# sourceMappingURL=Validation.js.map
